//"use client"

import "./SolutionServices.css"
import { useState, useEffect, useRef } from "react"
import solS1 from "./../../../Assets/Group 13.png"
import solS2 from "./../../../Assets/Group 14.png"
import solS3 from "./../../../Assets/Group 15.png"
import solS4 from "./../../../Assets/Group 16.png"
import solS5 from "./../../../Assets/Group 17.png"
import solS6 from "./../../../Assets/Group 18.png"
import solS7 from "./../../../Assets/Group 19.png"
import solS8 from "./../../../Assets/Group 20.png"
import solS9 from "./../../../Assets/Group 21.png"
import solS10 from "./../../../Assets/Group 22.png"
import solS11 from "./../../../Assets/Group 18.png"
import solS12 from "./../../../Assets/Group 19.png"
import { Link } from "react-router-dom"

function SolutionServices() {
  const [hoveredCard, setHoveredCard] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const sectionRef = useRef(null)

  const handleMouseEnter = (card) => {
    setHoveredCard(card)
  }

  const handleMouseLeave = () => {
    setHoveredCard(null)
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === sectionRef.current) {
            setIsVisible(entry.isIntersecting)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [])

  const services = [
    {
      id: "custom-software",
      link: "/custom-software-development",
      defaultImg: solS1,
      hoverImg: solS9,
      title: "Custom Software Development",
      description:
        " We design scalable, custom-built software that streamlines workflows, boosts efficiency, and drives digital growth.",
    },
    {
      id: "digital-commerce",
      link: "/digital-commerce",
      defaultImg: solS2,
      hoverImg: solS10,
      title: "Digital Commerce",
      description:
        " We create fast, SEO-optimized eCommerce platforms that improve user experience, conversions, and online sales.",
    },
    {
      id: "crm-platform",
      link: "/crm-platform-implementation",
      defaultImg: solS3,
      hoverImg: solS11,
      title: "CRM Platform Implementation",
      description:
        " We implement powerful CRM systems to automate workflows, manage leads, and improve customer engagement.",
    },
    {
      id: "generative-ai",
      link: "/generative-ai",
      defaultImg: solS4,
      hoverImg: solS12,
      title: "Generative AI",
      description:
        " We develop generative AI solutions to automate content creation, design, and business process innovation.",
    },
    {
      id: "machine-learning",
      link: "/machine-learning",
      defaultImg: solS5,
      hoverImg: solS9,
      title: "Machine Learning",
      description:
        " We build machine learning models for predictive analytics, automation, and data-driven decision-making.",
    },
    {
      id: "software-engineering",
      link: "/software-engineering",
      defaultImg: solS6,
      hoverImg: solS10,
      title: "Software Engineering",
      description:
        "We deliver robust, secure, and scalable software engineering solutions for enterprise-level applications.",
    },
    {
      id: "cloud-engineering",
      link: "/cloud-engineering",
      defaultImg: solS7,
      hoverImg: solS11,
      title: "Cloud Engineering",
      description:
        " We optimize cloud infrastructure for performance, scalability, cost-efficiency, and secure digital transformation.",
    },
    {
      id: "data-engineering",
      link: "/data-engineering",
      defaultImg: solS8,
      hoverImg: solS12,
      title: "Data Engineering",
      description:
        " We create efficient data pipelines to collect, store, and process information for actionable insights.",
    },
    {
      id: "rpa-ipa",
      link: "/rpa-ipa-implementation",
      defaultImg: solS9,
      hoverImg: solS1,
      title: "RPA & IPA Implementation",
      description:
        " We implement RPA and intelligent automation to streamline operations and eliminate repetitive tasks.",
    },
    {
      id: "product-strategy",
      link: "/product-strategy-consulting",
      defaultImg: solS10,
      hoverImg: solS2,
      title: "Product Strategy & Consulting",
      description:
        " We provide expert product strategy to design, launch, and scale impactful digital solutions.",
    },
    {
      id: "graphics-designing",
      link: "/graphics-designing",
      defaultImg: solS11,
      hoverImg: solS3,
      title: "Graphics Designing",
      description:
        " We design visually compelling graphics that enhance brand identity and user engagement",
    },
    {
      id: "system-integration",
      link: "/system-integration",
      defaultImg: solS12,
      hoverImg: solS4,
      title: "System Integration",
      description:
        " We integrate complex systems for seamless data flow, connectivity, and improved business efficiency.",
    },
  ]

  return (
    <div className={`main_div_solution_services ${isVisible ? "animate-in" : ""}`} ref={sectionRef}>
      <div className="header_content">
        <p className={`services_heading ${isVisible ? "slide-up" : ""}`}>Our Services</p>
        <h2 className={`para_services ${isVisible ? "slide-up delay-1" : ""}`}>
          IT Solutions &amp; Services We Offer
        </h2>
        <div className={`hr_line_blue ${isVisible ? "expand-width delay-2" : ""}`}></div>
      </div>

      <div className="row p-10 m-10">
        <div className="col-12">
          <div className="row m-0 p-0 justify-content-center">
            {services.map((service, index) => (
              <div key={service.id} className="col-lg-3 col-md-6 col-sm-6 col-12 d-flex">
                <Link to={service.link}>
                  <div
                    className={`card_div_main ${isVisible ? "card-animate-in" : ""}`}
                    onMouseEnter={() => handleMouseEnter(service.id)}
                    onMouseLeave={handleMouseLeave}
                    style={{
                      transitionDelay: `${Math.min(index * 0.05, 0.3)}s`,
                    }}
                  >
                    <div className="card_background_gradient"></div>
                    <div className="card_content">
                      <div className="icon_container">
                        <img
                          src={hoveredCard === service.id ? service.hoverImg : service.defaultImg}
                          className="icon_card_services"
                          width="64"
                          height="64"
                          loading="lazy"
                          alt=""
                        />
                        <div className="icon_glow"></div>
                      </div>
                      <div className="text_content">
                        <h3 className="heading_services_card">{service.title}</h3>
                        <p className="para_card_services">{service.description}</p>
                      </div>
                      <div className="card_hover_overlay">
                        <div className="hover_arrow">→</div>
                      </div>
                    </div>
                    <div className="card_shine"></div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SolutionServices